import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faPlug, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

type SettingsNavigationProps = {
  // eslint-disable-next-line no-unused-vars
  onNavigate?: (_to: string, _isActive: boolean) => boolean | void;
};

const settingsItems = [
  { to: '/settings/general', labelKey: 'settings.sidebar.general', label: 'General del Comercio', icon: faCog },
  { to: '/settings/connections', labelKey: 'settings.sidebar.connections', label: 'Conexiones', icon: faPlug },
  { to: '/settings/legal', labelKey: 'settings.sidebar.legal', label: 'Legal y Privacidad', icon: faShieldAlt },
];

const SettingsNavigation: React.FC<SettingsNavigationProps> = ({ onNavigate }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [hoveredItemId, setHoveredItemId] = React.useState<string | null>(null);

  return (
    <nav aria-label={t('settings.title', 'Ajustes')} className="flex-1 space-y-1.5 overflow-y-auto">
      {settingsItems.map((item) => {
        const isCurrentRoute = location.pathname === item.to;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            onClick={(event) => {
              if (onNavigate?.(item.to, isCurrentRoute) === false) event.preventDefault();
            }}
            onMouseEnter={() => setHoveredItemId(item.to)}
            onMouseLeave={() => setHoveredItemId(null)}
            className={({ isActive }) =>
              [
                'group flex items-center gap-3 px-3.5 py-2.5 rounded-xl transition-all duration-300 motion-reduce:transition-none font-semibold border-none cursor-pointer text-sm',
                isActive
                  ? 'text-white bg-blue-600/50 shadow-inner-glow shadow-inner-glow-white-sm text-shadow-glow-white'
                  : hoveredItemId === item.to
                    ? 'text-white bg-black/60 shadow-inner-glow shadow-inner-glow-white-sm text-shadow-glow-white'
                    : 'text-white bg-transparent',
              ].join(' ')
            }
          >
            {({ isActive }) => (
              <>
                <FontAwesomeIcon
                  icon={item.icon}
                  className="shrink-0 w-4 h-4 transition-all duration-300 motion-reduce:transition-none"
                  style={isActive || hoveredItemId === item.to ? { filter: 'drop-shadow(0 0 6px rgba(255, 255, 255, 0.8))' } : {}}
                />
                <span className="truncate tracking-wide">{t(item.labelKey, item.label)}</span>
              </>
            )}
          </NavLink>
        );
      })}
    </nav>
  );
};

export default SettingsNavigation;
